import React from 'react';

import SignIn from 'components/home/signIn';

const Extension = () => {

	return (
    <SignIn />
  );
}

export default Extension;